import { WebStaticsAnalysis } from '@loc/helpers/src/Analysis'

export const sa = new WebStaticsAnalysis()
